module.exports = __webpack_public_path__ + "3fb1d6c43246cdf991a11dfe826dfe99.gif";